import { render, staticRenderFns } from "./bulk-update-upload.vue?vue&type=template&id=5e6ea46c&scoped=true"
import script from "./bulk-update-upload.vue?vue&type=script&lang=ts"
export * from "./bulk-update-upload.vue?vue&type=script&lang=ts"
import style0 from "./bulk-update-upload.vue?vue&type=style&index=0&id=5e6ea46c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6ea46c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e6ea46c')) {
      api.createRecord('5e6ea46c', component.options)
    } else {
      api.reload('5e6ea46c', component.options)
    }
    module.hot.accept("./bulk-update-upload.vue?vue&type=template&id=5e6ea46c&scoped=true", function () {
      api.rerender('5e6ea46c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/comment-edit/bulk-update/bulk-update-upload.vue"
export default component.exports